export const CALENDLY_URL = "https://calendly.com/alignedk12/30min";
export const ALIGNMENT_CHECK_URL = "https://form.jotform.com/edtechdepot/the-alignment-check";

// Logo variants — pick the right one for the surface.
// - Header (light cream bg) uses the Stacked Light variant — sits directly on the cream
//   without a card/box around it for a cleaner, more native feel.
// - Footer (dark navy bg) uses the Stacked Dark variant.
// - Favicon / OG card uses the rounded-square app icon.
export const BRAND_LOGO_LIGHT_BG = "https://customer-assets.emergentagent.com/job_k12-solutions/artifacts/ai4a6g9x_Logo-%20Stacked-%20Light.png";
export const BRAND_LOGO_DARK_BG = "https://customer-assets.emergentagent.com/job_k12-solutions/artifacts/j59he6fm_Logo-%20Main-%20Dark.png";
export const BRAND_LOGO_STACKED = "https://customer-assets.emergentagent.com/job_k12-solutions/artifacts/a5f7qlrc_Logo-%20Stacked-%20Dark.png";
export const BRAND_APP_ICON = "https://customer-assets.emergentagent.com/job_k12-solutions/artifacts/69jlt559_Logo-%20App%20Icon-Light.png";

// Backwards-compat (any old refs land on the new light-bg stacked variant)
export const BRAND_LOGO = BRAND_LOGO_LIGHT_BG;

export const SOLUTIONS = [
  {
    slug: "attendance-intervention-system",
    path: "/solutions/attendance-intervention-system",
    name: "Attendance Intervention System",
    short: "Attendance Intervention",
    tagline: "Identify at-risk students, recognize patterns, and take clear, consistent action every week.",
    outcomes: [
      "Improve overall attendance",
      "Reduce Tier 3 student growth",
      "Increase consistency across your team",
    ],
  },
  {
    slug: "behavior-consistency-system",
    path: "/solutions/behavior-consistency-system",
    name: "Behavior Consistency System",
    short: "Behavior Action",
    tagline: "Bring order, clarity, and consistency to student behavior response.",
    outcomes: [
      "Clearer incident visibility",
      "More consistent staff response",
      "Stronger intervention follow-through",
    ],
  },
  {
    slug: "enrollment-follow-through-system",
    path: "/solutions/enrollment-follow-through-system",
    name: "Enrollment Follow Through System",
    short: "Enrollment Follow Through",
    tagline: "Capture every inquiry, follow up instantly, and guide families from interest to enrollment — automatically.",
    outcomes: [
      "Every inquiry captured and followed up",
      "Families stay engaged",
      "Enrollment becomes consistent and trackable",
    ],
  },
];
